import { render } from "./BookingProvider.vue?vue&type=template&id=4a8bd224&ts=true"
import script from "./BookingProvider.vue?vue&type=script&lang=ts"
export * from "./BookingProvider.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__